import { GeometryManagementApi, TollDomainApi, VariantApi } from 'ctp-toll-domain';
import { routes } from '@/constants/routes/routes';
import userManager from '@/auth';

const apiConfig = {
  accessToken: () => userManager.getApiKey().replace('Bearer ', '')
};

export const TollDomainApiCaller = new TollDomainApi(
  apiConfig,
  routes.apiRoutes.basePath
);

export const TollDomainGeometryApiCaller = new GeometryManagementApi(
  apiConfig,
  routes.apiRoutes.basePath
);

export const TollDomainVariantApiCaller = new VariantApi(
  apiConfig,
  routes.apiRoutes.basePath
);

export default { TollDomainApiCaller, TollDomainGeometryApiCaller, TollDomainVariantApiCaller };
